import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { LocationStrategy, HashLocationStrategy } from "@angular/common";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppComponent } from "./app.component";
import { DefaultLayoutComponent } from "./containers";
import { SessionCountdownComponent } from "./containers/default-layout/session-countdown.component";
import { DefaultHeaderComponent } from "./containers/default-layout/default-header.component";
import { DefaultFooterComponent } from "./containers/default-layout/default-footer.component";
import { P404Component } from "./views/error/404.component";
import { P500Component } from "./views/error/500.component";
import { LoginComponent } from "./views/login/login.component";
import { ConfirmationModalComponent } from "./views/shared/confirmation-modal/confirmation-modal.component";
import { ChangePasswordModalComponent } from "./views/shared/change-password-modal/change-password-modal.component";
import { ResetPasswordModalComponent } from "./views/shared/reset-password-modal/reset-password-modal.component";
import { InvoiceRefundModalComponent } from "./views/shared/invoice-refund-modal/invoice-refund-modal.component";
import { EditRefundModalComponent } from "./views/shared/edit-refund-modal/edit-refund-modal.component";

import { NgOptimizedImage } from "@angular/common";

// Import routing module
import { AppRoutingModule } from "./app.routing";

// Import 3rd party components
import { httpInterceptorProviders } from "./interceptors";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { en_US, NZ_I18N } from "ng-zorro-antd/i18n";
import { provideNzIcons } from "ng-zorro-antd/icon";
import {
  CheckCircleOutline,
  CheckOutline,
  ClockCircleOutline,
  CloseCircleOutline,
  CloseOutline,
  CommentOutline,
  CopyOutline,
  DeleteOutline,
  DollarOutline,
  DownloadOutline,
  EditOutline,
  ExclamationCircleOutline,
  ExportOutline,
  EyeOutline,
  FileDoneOutline,
  LoadingOutline,
  LockOutline,
  PlusOutline,
  QuestionCircleOutline,
  RedoOutline,
  ReloadOutline,
  RobotOutline,
  RollbackOutline,
  SaveOutline,
  SearchOutline,
  SelectOutline,
  ShareAltOutline,
  SwapOutline,
  SyncOutline,
  UnorderedListOutline,
  WarningOutline,
} from "@ant-design/icons-angular/icons";
import { NgxSpinnerModule } from "ngx-spinner";
import { provideNgxMask } from "ngx-mask";

const NZ_ICONS_USED = [
  CheckCircleOutline,
  CheckOutline,
  ClockCircleOutline,
  CloseCircleOutline,
  CloseOutline,
  CommentOutline,
  CopyOutline,
  DeleteOutline,
  DollarOutline,
  DownloadOutline,
  EditOutline,
  ExclamationCircleOutline,
  ExportOutline,
  EyeOutline,
  FileDoneOutline,
  LoadingOutline,
  LockOutline,
  PlusOutline,
  QuestionCircleOutline,
  RedoOutline,
  ReloadOutline,
  RobotOutline,
  RollbackOutline,
  SaveOutline,
  SearchOutline,
  SelectOutline,
  ShareAltOutline,
  SwapOutline,
  SyncOutline,
  UnorderedListOutline,
  WarningOutline,
];

const APP_CONTAINERS = [
  DefaultLayoutComponent,
  SessionCountdownComponent,
  DefaultHeaderComponent,
  DefaultFooterComponent,
];

import {
  BreadcrumbModule,
  DropdownModule,
  FooterModule,
  HeaderModule,
  SidebarModule,
} from "@coreui/angular";
import { IconModule } from "@coreui/icons-angular";

@NgModule({ declarations: [
        AppComponent,
        ...APP_CONTAINERS,
        P404Component,
        P500Component,
        LoginComponent,
        ConfirmationModalComponent,
        ChangePasswordModalComponent,
        ResetPasswordModalComponent,
        InvoiceRefundModalComponent,
        EditRefundModalComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        BreadcrumbModule,
        DropdownModule,
        FooterModule,
        HeaderModule,
        SidebarModule,
        IconModule,
        FormsModule,
        ReactiveFormsModule,
        NgxSpinnerModule,
        NgOptimizedImage], providers: [
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy,
        },
        httpInterceptorProviders,
        // Root-level mask config: components opened via BsModalService (e.g. the
        // Create Quotation modal) resolve DI through the root injector, not their
        // lazy module's injector, so provideNgxMask() must also exist here.
        provideNgxMask(),
        { provide: NZ_I18N, useValue: en_US },
        provideNzIcons(NZ_ICONS_USED),
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
